export const errorMessages = {
    REQUIRED_FIELD: "This field is required",
    INVALID_PHONE_NUMBER: "Phone number can only contain numbers, +, and -",
    PHONE_NUMBER_LENGTH: "Phone number must be between 7 and 15 characters",
    INVALID_EMAIL_OR_PHONE: "Please enter a valid email or phone number",
    INVALID_EMAIL: "Please enter a valid email address",
    INVALID_PASSWORD: "Password must be at least 8 characters and contain uppercase, lowercase, and special characters",
    PASSWORD_MISMATCH: "Passwords do not match",
    ERROR_OCCURRED: "An error occurred",
    UNKNOWN_ERROR_OCCURRED: "An unknown error occurred",
    COULD_NOT_FIND_THIS_PAGE: "Could not find this page",
    INVALID_OPTION: "Invalid Option",
    SOMETHING_WENT_WRONG: "Something Went Wrong",
    FAILED_RESET_PASSWORD: "Failed to Reset Password",
    LOGIN_FAILED: "Login Failed",
    FAILED_PROFILE_IMAGE_UPLOAD: "Failed To Upload Profile Picture",
    FAILED_GOOGLE_SIGNIN: "An Error Occured While Redirecting to Google",
    INVALID_NUMBER: "Invalid Number",
    CHARACTOR_LENGTH_30: "Minimum 30 Charactors needed",
    ORDER_INSTRUCTIONS_MAX_LENGTH: "Order instructions must be 5000 characters or fewer",
    TOPIC_MAX_LENGTH: "Topic must be 200 characters or fewer",
    INVALID_ORDER_ID: "Order ID must be at least 6 characters long and start with 'ID'",
    INVALID_WRITER_ID: "Writer ID must be at least 6 characters long and start with 'ID'"
}
